import React, { useMemo } from "react";
import {
  Area, AreaChart, CartesianGrid, ResponsiveContainer, Tooltip, XAxis, YAxis,
} from "recharts";
import { AXIS, LABEL_STYLE, SMALL_CHART_MARGIN, TOOLTIP_STYLE } from "@/lib/chartStyles";

export function FaultReadingChart({ reading }) {
  const data = useMemo(
    () =>
      (reading.series || []).map((r) => ({
        ts: r.ts,
        label: new Date(r.ts).toLocaleString(undefined, { month: "short", day: "numeric", hour: "numeric" }),
        val: typeof r.val === "object" ? r.val?.val : r.val,
      })),
    [reading]
  );
  return (
    <div className="mt-5" data-testid={`fault-reading-${reading.point_id}`}>
      <div className="flex items-center justify-between">
        <div className="text-sm font-heading font-semibold text-[#212121]">{reading.dis}</div>
        <div className="k-sublabel">{reading.unit || ""}</div>
      </div>
      <div className="mt-2 h-40">
        <ResponsiveContainer width="100%" height="100%">
          <AreaChart data={data} margin={SMALL_CHART_MARGIN}>
            <defs>
              <linearGradient id={`g-${reading.point_id}`} x1="0" y1="0" x2="0" y2="1">
                <stop offset="0%" stopColor="#156F5B" stopOpacity={0.35} />
                <stop offset="100%" stopColor="#156F5B" stopOpacity={0.02} />
              </linearGradient>
            </defs>
            <CartesianGrid stroke="#F0F2F1" vertical={false} />
            <XAxis dataKey="label" tick={AXIS} interval="preserveStartEnd" minTickGap={60} />
            <YAxis tick={AXIS} width={48} />
            <Tooltip contentStyle={TOOLTIP_STYLE} labelStyle={LABEL_STYLE} />
            <Area type="monotone" dataKey="val" stroke="#156F5B" strokeWidth={1.5} fill={`url(#g-${reading.point_id})`} />
          </AreaChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
}
